import React, { Fragment } from 'react';
import { GOOGLE_MAPS_EVENT } from '@/constants';
import { styWrapper } from './styles';

function LocationSection() {
  return (
    <Fragment>
      <div id="fh5co-couple-story" className="fh5co-section-gray" css={styWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
              <h2 className="main-font">Lokasi Acara</h2>
              <p className="sub-title">
                <a
                  href={GOOGLE_MAPS_EVENT}
                  title="Click untuk melihat peta di Google Maps"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: '#828282' }}
                >
                  <strong>Pesta Keboen Restoran, Kota Semarang</strong>
                </a>{' '}
                <br />
                Jl. Veteran no. 29, Lempongsari <br />
                Kota Semarang
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15840.428345180902!2d110.4153671!3d-6.9966684!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e708b67ee1c6343%3A0x90a5f503260f6e5e!2sPesta%20Keboen%20Restoran!5e0!3m2!1sen!2sid!4v1675609088339!5m2!1sen!2sid"
                width="100%"
                height="450"
                frameBorder="0"
                style={{ border: '0' }}
                allowFullScreen
                aria-hidden="false"
                tabIndex="0"
                title="Google Maps - Mira & Wanto Wedding Party"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default React.memo(LocationSection);
